const ViewActivityApply = () => import('../modules/xmsb/energy/operators/ViewActivityApplyGzl')

export default [
  {

    path: '/activityapplyview',
    name: 'activityapplyview',
    component: ViewActivityApply,
    meta: {
      title: '申请对外投资合作促进活动费用补贴',
      fullscreen: true,
    },
  },
]
